import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import * as firebase from 'firebase';

/**
 * Receives user props from header
 *
 * This is the login button component and deals with google oauth
 */
class OAuth extends Component {

    constructor(props) {
        console.log("OAuth constructor ", props);
        super(props);
        this.state = {
          navTo: false
        };
        this.authenticate = this.authenticate.bind(this);
        this.signout = this.signout.bind(this);
    }

    //redirects user to google oauth url
    anonymous(user){
        console.log("OAuth authenticate ", user);
        firebase.auth().signInAnonymously().catch(function(error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log("ERROR!!");
        });
    }

    authenticate(user){
        let provider = new firebase.auth.GoogleAuthProvider();
        console.log("trying to login with " + provider);
        firebase.auth().signInWithRedirect(provider)
    }

    emailauthenticate(user){
      this.setState({navTo: true});
        // let provider = new firebase.auth.GoogleAuthProvider();
        // console.log("trying to login with " + provider);
        // firebase.auth().signInWithRedirect(provider)
    }

    //logouts user from firebase app
    signout(user) {
        console.log("OAuth signout ", user);
        sessionStorage.clear();
        this.props.user.logout();
        return firebase.auth().signOut();
    }

    render() {
        if (!!this.state.navTo){
          return <Redirect to={'/login'} />;
        }
        //console.log("OAuth render");
        return (
            <div>
                <div className='oauth'>
                    {
                        //conditionally renders based on authed status(userStore.authed)
                        !this.props.user.authed
                            ?
                            <span>
                            <button onClick={this.anonymous} className="sign-in-button">
                                Sign in Anonymously
                            </button>
                            {/*<button onClick={this.emailauthenticate.bind(this)} className="sign-in-button">
                                Sign in with Email
                            </button>*/}
                            </span>
                            :
                            <div className="sign-out-text">
                              <div className="sign-out-name">
                                  {this.props.user.displayName || "Welcome"}
                              </div>
                              <div onClick={this.signout} className="sign-out-button">
                                  log out
                              </div>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default OAuth;



// WEBPACK FOOTER //
// ./src/components/OAuth.js